module.exports = __webpack_public_path__ + "static/img/market.d3da229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/market.jpg
// module id = 239
// module chunks = 6